<template>
  <div class="workbench-carousel carousel mb15">
   <!-- 轮播 -->

    <el-carousel height="96px">
      <el-carousel-item v-for="(item,idx) in (bannerInfo&&bannerInfo.bannerPictureDtos)||[]" :key="item.bannerPictureInfoId">
        <img @click="toPath(item.bannerPictureJumpLink)" :src="item.bannerPicturePath" alt="">
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
export default {
  props: ['bannerInfo'],
  data () {
    return {
    }
  },
  created () {

  },
  methods: {
    toPath(url,params={}){
      if (url.indexOf('http://') > -1 || url.indexOf('https://') > -1) {
        window.open(url, '_blank');
      } else {
        let routeData = this.$router.resolve({
          path: url,
          query:params
        });
        window.open(routeData.href, '_blank');
      }
    }
  }
}
</script>
<style lang="stylus">
  .workbench-carousel{
    &.carousel {
      position: relative;
      border-radius: 4px;
      overflow: hidden;
    }
    &.carousel.mb15{
      margin-bottom: 15px;
    }

    .el-carousel__item:hover{
      cursor: pointer;
    }
    .el-carousel__item h3 {
      color: #475669;
      font-size: 14px;
      opacity: 0.75;
      line-height: 96px;
      margin: 0;
    }

    .el-carousel__item:nth-child(2n) {
      background-color: #99a9bf;
    }

    .el-carousel__item:nth-child(2n+1) {
      background-color: #d3dce6;
    }
    &.carousel .el-carousel__item img{
      width:100%;
      height:100%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/workBench/components/carousel.vue